"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Signature.module.css"));
var mobx_react_1 = require("mobx-react");
var moment = require("moment");
var react_1 = require("react");
var Signature = (function (_super) {
    __extends(Signature, _super);
    function Signature(props) {
        var _this = _super.call(this, props) || this;
        _this.json_data = props.model.json_data;
        props.model.dispatcher.addListener(function () {
            console.log("Updating data in signature", props.model.json_data);
            _this.json_data = props.model.json_data;
            _this.forceUpdate();
        });
        return _this;
    }
    Signature.prototype.onClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, id, onChange, model;
            return __generator(this, function (_b) {
                _a = this.props, id = _a.id, onChange = _a.onChange, model = _a.model;
                if (!this.json_data.signature) {
                    window.dispatchEvent(new Event("show_signature_popup"));
                    return [2];
                }
                this.json_data[id] = "1";
                this.json_data[id + "_date"] = moment.utc().format();
                console.log("Signing", this.json_data);
                model.dispatcher.dispatch();
                return [2];
            });
        });
    };
    Signature.prototype.render = function () {
        var _a = this.props, id = _a.id, onChange = _a.onChange, model = _a.model, _b = _a.errors, errors = _b === void 0 ? {} : _b;
        var error = errors[id];
        var src = model.json_data[this.props.type] || "#";
        var isSigned = Boolean(model.json_data[this.props.id]);
        console.log("RENDER:", src);
        var html = React.createElement("img", { src: src, width: "150", height: "75" });
        if (!isSigned) {
            html = (React.createElement("button", { onClick: this.onClick.bind(this), className: styles.button }, "Sign"));
        }
        var date = "";
        if (isSigned) {
            date = moment(this.json_data[id + "_date"]).format("MM/DD/YYYY");
        }
        return (React.createElement("table", { className: styles.root },
            React.createElement("tbody", null,
                React.createElement("tr", { className: styles.line },
                    React.createElement("td", { className: styles.cell },
                        React.createElement("div", { className: styles.box }, html),
                        error && React.createElement("p", { className: styles.error },
                            error,
                            " ")),
                    React.createElement("td", { className: styles.cell },
                        this.json_data["first_name"],
                        " ",
                        this.json_data["last_name"]),
                    React.createElement("td", { className: styles.cell }, date)),
                React.createElement("tr", { className: styles.line },
                    React.createElement("td", { className: styles.cell },
                        React.createElement("em", null, "Signature")),
                    React.createElement("td", { className: styles.cell },
                        React.createElement("em", null, "Print Name")),
                    React.createElement("td", { className: styles.cell },
                        React.createElement("em", null, "Date"))))));
    };
    Signature.defaultProps = {
        type: "signature"
    };
    Signature = __decorate([
        mobx_react_1.observer
    ], Signature);
    return Signature;
}(react_1.Component));
exports.Signature = Signature;
//# sourceMappingURL=data:application/json;base64,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